import React from 'react';
import { Card, CardHeader, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import type { Person } from '../../../../types';
// ✅ REUSE existing tab component
import { ResearchTab } from '../../../../components/profiles/tabs/ResearchTab';

interface ResearchPanelProps {
  personId: string;
  person: Person;
  showMetadata?: boolean;
  metadataFormat?: 'short' | 'long';
}

/**
 * ResearchPanel - Wraps existing ResearchTab with consistent styling
 *
 * This panel reuses 100% of the existing ResearchTab component,
 * just adding a Card wrapper with consistent header styling.
 */
export const ResearchPanel: React.FC<ResearchPanelProps> = ({
  personId,
  person,
  showMetadata = false,
  metadataFormat = 'short'
}) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    navigate(`/people/${personId}/research`);
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader
        title="Research"
        action={
          <Typography
            component="a"
            variant="caption"
            sx={{
              cursor: 'pointer',
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
            onClick={handleViewAll}
          >
            View All →
          </Typography>
        }
      />

      {/* ✅ Reuse existing ResearchTab - zero changes needed */}
      <ResearchTab person={person} />
    </Card>
  );
};
